///@ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  Checkbox,
  TextField,
  FormControlLabel,
  Box,
  Chip,
  Autocomplete,
  Popper,
} from "@mui/material";

import { post, get } from "requests";
import CustomModal from "components/CustomModal";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDButtonRoot from "components/MDButton/MDButtonRoot";
import { Modal, Typography } from "@mui/material";
import EmailPreviewComponent from "./EmailPreviewComponent";
import { useStoreActions, useStoreState } from "easy-peasy";
import { DeleteForever, MailOutlineOutlined } from "@mui/icons-material";
import ClickAwayListener from "@mui/material/ClickAwayListener";

interface CheckboxState {
  id: string;
  value: string;
  checked: boolean;
}

interface User {
  name: string;
  email: string;
}

interface SendEmailComponentProps {
  dealApplicationId: any;
  showModal: boolean;
  onClose: boolean;
  isDecline: boolean;
  isPreApproved: boolean;
  dealApplication: any;
  handleSend: (data: any, skip: boolean) => void;
  emailTemplateName: any;
  setEmailTemplateName: (data: any) => void;
}

const SendStatusEmailModal: React.FC<SendEmailComponentProps> = ({
  showModal,
  onClose,
  handleSend,
  dealApplicationId,
  isDecline,
  isPreApproved,
  dealApplication,
  emailTemplateName,
  setEmailTemplateName,
}) => {
  const [checkboxes, setCheckboxes] = useState<CheckboxState[]>([
    { id: "funders", value: "Funder", checked: true },
    { id: "merchantOwners", value: "Merchant Owner(s)", checked: true },
    { id: "salesrep", value: "Representative", checked: true },
    { id: "isobroker", value: "ISO/Broker", checked: true },
  ]);

  const [finalEmailRecipients, setFinalEmailRecipients] = useState<User[]>([]);
  const [emailUsers, setEmailUsers] = useState<Record<string, User[]>>({});
  const [newEmail, setNewEmail] = useState("");
  const [additionalDropdownUsers, setAdditionalDropdownUsers] = useState<User[]>([]);
  const [dropDownSelectedUsers, setDropdownSelectedUsers] = useState<User[]>([]);
  const [emailDataComponents, setEmailDataComponents] = useState([]);
  const [selectedEmailComponents, setSelectedEmailComponents] = useState([]);
  const [isEmailEditModal, setIsEmailEditModal] = useState(false);
  const [emailContent, setEmailContent] = useState({});
  const [emailDeclineReason, setEmailDeclineReason] = useState("");
  const [applicationDeclineReasons, setApplicationDeclineReasons] = useState<any>([]);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const storeActiveStep = useStoreState((state) => state.dealApplication.activeStep);
  const [isAutoSubmitted, setIsAutoSubmitted] = useState(false);

  const storeEmailContent = useStoreState((state) => state.dealApplication.emailContent);
  const setStoreEmailContent = useStoreActions(
    (actions) => actions.dealApplication.setEmailContent
  );

  const replyOnSameThread = useStoreState((state) => state.dealApplication.replyOnSameThread);
  const setReplyOnSameThread = useStoreActions(
    (actions) => actions.dealApplication.setReplyOnSameThread
  );
  const selectedRows = useStoreState((state: any) => state.offerStore.selectedRows);

  useEffect(() => {
    fetchRecipientsByCategory();
    getAllEmailDetails();
    fetchApplicationDeclineReasons();
    getIsAutoSubmittedApplication();
  }, []);

  useEffect(() => {
    const filteredList = dropDownSelectedUsers.filter((user) => {
      const email = user && user.value && user.value.email;
      return !finalEmailRecipients.some((recipient) => recipient.email === email);
    });
    setDropdownSelectedUsers(filteredList);
  }, [finalEmailRecipients]);

  useEffect(() => {
    checkboxes.forEach((checkbox, index) => {
      handleCheckBoxChange(index);
    });
  }, [additionalDropdownUsers]);

  const handleNext = async () => {
    await fetchEmailTemplate();
    setIsEmailEditModal(true);
  };

  const handleBack = async () => {
    setIsEmailEditModal(false);
  };

  const clearAllStates = () => {
    setFinalEmailRecipients([]);
    setSelectedEmailComponents([]);
    setStoreEmailContent({});
    setIsAutoSubmitted(false);
    setReplyOnSameThread(false);
    setEmailTemplateName(null);

    onClose();
  };

  const fetchApplicationDeclineReasons = async () => {
    const response = await get("getApplicationDeclineReasons");
    setApplicationDeclineReasons(response);
  };

  const getAllEmailDetails = async () => {
    let status = "Pending";
    let subStatus = storeActiveStep - 1;

    if (isDecline) {
      status = "Closed";
      subStatus = "Declined";
    }

    if (isPreApproved) {
      status = "Closed";
      subStatus = "Pre-Approved";
    }

    const payload = {
      dealApplicationId: dealApplicationId,
      status: status,
      subStatus: subStatus,
    };

    const response = await post("application/getFundingEmailDatapoints", payload);
    const options = Object.keys(response).map((key) => ({
      value: response[key],
      label: key,
    }));
    setSelectedEmailComponents(options);
    setEmailDataComponents(options);
  };

  const fetchRecipientsByCategory = async () => {
    const responseData = await post("fetchRecipientsByCategory", {
      applicationId: dealApplicationId,
    });

    setEmailUsers(responseData);
    setAdditionalDropdownUsers(responseData.users?.filter((usr: User) => usr.email) || []);
    setFinalEmailRecipients(responseData?.defaultRecipients || []);
  };

  const getIsAutoSubmittedApplication = async () => {
    try {
      const r = await get("dealApplication/isAutoSubmitted/" + dealApplicationId);
      setIsAutoSubmitted(r);
      setReplyOnSameThread(r);
    } catch (error) {
      console.error("Error fetching auto-submitted status:", error);
      setReplyOnSameThread(false);
      setIsAutoSubmitted(false);
    }
  };

  const fetchEmailTemplate = async () => {
    let status = "Pending";
    let subStatus = storeActiveStep - 1;

    if (isDecline) {
      status = "Closed";
      subStatus = "Declined";
    }

    if (isPreApproved) {
      status = "Closed";
      subStatus = "Pre-Approved";
    }

    const emailBodyList = selectedEmailComponents.map((selected) => selected.value);
    const payload = {
      dealApplicationId: dealApplicationId,
      status: status,
      subStatus: subStatus,
      emailData: emailBodyList,
      offersToSend: selectedRows || [],
    };
    const response = await post("statusUpdateEmailTemplate", payload);
    setEmailContent(response);
    setEmailTemplateName(response?.templateName);
    const content = response && response.content ? response.content : "";
    setStoreEmailContent({
      content: content,
    });
  };

  const handleCheckBoxChange = (index) => {
    const updatedCheckboxes = [...checkboxes];
    updatedCheckboxes[index].checked = !updatedCheckboxes[index].checked;
    setCheckboxes(updatedCheckboxes);
    populateEmailSenders(updatedCheckboxes[index].id);
  };

  const populateEmailSenders = (id) => {
    let recipients = [];
    let recipientsRemoved = [];
    const checkedBox = checkboxes.filter((box) => box.id === id)[0];
    if (checkedBox.checked) {
      const addedUsers = emailUsers && emailUsers[id];
      if (addedUsers) {
        recipients = [...recipients, ...addedUsers.filter((user) => user.email)];
      }
    } else {
      const removedUsers = emailUsers && emailUsers[id];
      if (removedUsers) {
        const checkedUsers = checkboxes
          .filter((box) => box.checked || box.id === id)
          .flatMap((box) => emailUsers[box.id]);
        removedUsers.forEach((eachUser) => {
          const isEmailInList = checkedUsers.some((usr) => usr.email === eachUser.email);
          const isDefaultUser =
            emailUsers &&
            emailUsers.defaultRecipients &&
            emailUsers.defaultRecipients.some((user) => user.email == eachUser.email);
          if (isEmailInList && !isDefaultUser) {
            recipientsRemoved.push(eachUser);
          }
        });
      }
    }
    setFinalEmailRecipients((prevState) => {
      const mergedList = [...prevState, ...recipients].filter(
        (recipient) =>
          !recipientsRemoved.some((removedUser) => removedUser.email === recipient.email)
      );
      const uniqueSet = new Set(mergedList.map((user) => JSON.stringify(user)));
      return Array.from(uniqueSet).map((entry) => JSON.parse(entry));
    });
  };

  const handleAddEmail = useCallback(() => {
    if (!isValidEmail(newEmail)) {
      alert("Please enter a valid email address.");
      return;
    }

    const isDuplicate = finalEmailRecipients.some(
      (recipient) => recipient.email === newEmail.trim()
    );
    if (isDuplicate) {
      alert("This email is already added.");
      return;
    }
    setFinalEmailRecipients((prevState) => [...prevState, { name: "", email: newEmail.trim() }]);
    setNewEmail("");
  }, [newEmail, finalEmailRecipients]);

  const updateEmailContent = (value: string) => {
    setStoreEmailContent({
      content: value,
    });
  };

  const prepareContent = (initialContent) => {
    if (initialContent && isDecline) {
      return initialContent.replace("{{declineReason}}", emailDeclineReason);
    }
    return initialContent;
  };

  const replaceDeclineReasonSubject = (email) => {
    if (email && email.subject && isDecline) {
      const content = email.subject;
      email.subject = content.replace("{{declineReason}}", emailDeclineReason);
      return email;
    }
    return email;
  };

  const isValidEmail = (email: string) => {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const handleRemoveUser = useCallback((index: number) => {
    setFinalEmailRecipients((prevState) => prevState.filter((_, i) => i !== index));
  }, []);

  const handleRemoveDropDownUser = useCallback((index: number) => {
    setDropdownSelectedUsers((prevState) => prevState.filter((_, i) => i !== index));
  }, []);

  const customOptions = useMemo(
    () =>
      additionalDropdownUsers
        .filter((usr) => !finalEmailRecipients.some((recipient) => recipient.email === usr.email))
        .map((usr) => ({
          label: `${usr.name} (${usr.email})`,
          value: usr,
        })),
    [additionalDropdownUsers, finalEmailRecipients]
  );

  const CustomPopper = (props: any) => {
    return (
      <Popper
        {...props}
        placement="bottom-end"
        style={{ zIndex: 1300 }}
        modifiers={[
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              rootBoundary: "document",
            },
          },
          {
            name: "flip",
            enabled: false,
          },
        ]}
      />
    );
  };

  const onSendButtonClick = async (isSkip: boolean = false) => {
    const payload = {
      content: storeEmailContent?.content,
      subject: emailContent?.subject,
    };
    await handleSend(payload, finalEmailRecipients, isSkip, isDecline);
    clearAllStates();
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setEmailDeclineReason(value);
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    setEmailDeclineReason(value);
    setIsDropdownVisible(false);
  };

  return (
    <Modal
      sx={{
        display: "flex",
        justifyContent: "center",
        maxWidth: "600px",
        margin: "auto",
        background: "transparent",
      }}
      open={showModal}
      onClose={clearAllStates}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: "20px",
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        }}
      >
        <MDBox
          sx={{
            background: "white",
            borderRadius: "16px",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            maxWidth: "md",
            width: "100%",
            padding: 3,
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <MDBox display="flex" justifyContent="space-between" alignItems="center">
            <MDBox>
              {isDecline ? (
                <MDBox display={"flex"} alignItems={"center"}>
                  <DeleteForever className="solid-icon" />
                  <Typography className="decline-modal-header" variant="h6">
                    DECLINE APPLICATION
                  </Typography>
                </MDBox>
              ) : (
                <MDBox display={"flex"} alignItems={"center"}>
                  <MailOutlineOutlined />
                  <Typography
                    className="decline-modal-header"
                    variant="display1"
                    style={{ marginLeft: "5px" }}
                  >
                    SEND NEXT (via EMAIL)
                  </Typography>
                </MDBox>
              )}
            </MDBox>
            <MDButton onClick={clearAllStates} variant="text" color="secondary">
              X
            </MDButton>
          </MDBox>

          {isEmailEditModal ? (
            <MDBox>
              <EmailPreviewComponent
                htmlContent={prepareContent(emailContent?.content ? emailContent?.content : "")}
                emailBody={replaceDeclineReasonSubject(emailContent)}
                setEmailBody={setEmailContent}
                updateStoreEmailContent={updateEmailContent}
              />
            </MDBox>
          ) : (
            <MDBox sx={{ flex: 1 }}>
              <MDBox>
                {isDecline && (
                  <MDBox marginTop={2} marginBottom={2}>
                    <MDBox width={"100%"} marginBottom={3}>
                      <MDTypography variant="subtitle2" fontWeight={"bold"}>
                        Decline Reason <span style={{ color: "red" }}>*</span>
                      </MDTypography>

                      <ClickAwayListener onClickAway={() => setIsDropdownVisible(false)}>
                        <MDBox sx={{ position: "relative", width: "80%" }}>
                          <MDInput
                            style={{ width: "100%", paddingRight: "30px" }}
                            type="text"
                            value={emailDeclineReason}
                            onChange={handleInputChange}
                            onFocus={() => setIsDropdownVisible(false)}
                          />

                          <span
                            onClick={() => {
                              setIsDropdownVisible((prevState) => !prevState);
                            }}
                            style={{
                              border: "1px solid #ddd",
                              paddingTop: 4,
                              paddingBottom: 4,
                              position: "absolute",
                              right: "10px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "all",
                              cursor: "pointer",
                              borderRadius: "4px",
                            }}
                          >
                            ▼
                          </span>

                          {isDropdownVisible && (
                            <select
                              value={
                                applicationDeclineReasons.some(
                                  (r) => r.declineReason === emailDeclineReason
                                )
                                  ? emailDeclineReason
                                  : ""
                              }
                              onChange={handleSelectChange}
                              size={
                                replyOnSameThread
                                  ? Math.min(applicationDeclineReasons.length + 1, 13)
                                  : Math.min(applicationDeclineReasons.length + 1, 22)
                              }
                              style={{
                                position: "absolute",
                                top: "100%",
                                width: "100%",
                                overflowY: "auto",
                                zIndex: 10,
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                boxSizing: "border-box",
                                padding: "4px",
                                marginTop: "2px",
                                backgroundColor: "white",
                                display: "block",
                                fontSize: "14px",
                                lineHeight: "1.8",
                              }}
                            >
                              <option value="" disabled hidden>
                                Select a reason
                              </option>
                              {applicationDeclineReasons.map((value, index) => (
                                <option
                                  key={index}
                                  value={value.declineReason}
                                  style={{
                                    padding: "8px 12px",
                                    fontSize: "14px",
                                    lineHeight: "1.6",
                                    cursor: "pointer",
                                  }}
                                >
                                  {value.declineReason}
                                </option>
                              ))}
                            </select>
                          )}
                        </MDBox>
                      </ClickAwayListener>
                    </MDBox>
                  </MDBox>
                )}
              </MDBox>

              {isAutoSubmitted && (
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={replyOnSameThread}
                      onChange={(event) => setReplyOnSameThread(event?.target?.checked)}
                    />
                  }
                  label="Send on Same thread"
                />
              )}

              {!replyOnSameThread && (
                <MDBox>
                  <MDTypography variant="subtitle2" fontWeight={"bold"}>
                    NOTIFICATION RECIPIENTS
                  </MDTypography>
                  <MDBox sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                    {checkboxes.map((checkbox, index) => (
                      <FormControlLabel
                        key={checkbox.id}
                        control={
                          <Checkbox
                            checked={checkbox.checked}
                            onChange={() => handleCheckBoxChange(index)}
                          />
                        }
                        label={checkbox.value}
                      />
                    ))}
                  </MDBox>

                  <MDBox sx={{ mt: 2 }}>
                    <MDTypography variant="subtitle2" fontWeight={"bold"} sx={{ marginBottom: 1 }}>
                      Add Recipients
                    </MDTypography>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect={true}
                      id="search-users"
                      options={customOptions}
                      getOptionLabel={(option) => `${option.label}`}
                      value={dropDownSelectedUsers}
                      onChange={(e, newValue) => setDropdownSelectedUsers(newValue as User[])}
                      renderInput={(params) => <TextField {...params} label="Search Users" />}
                      renderTags={(value, getTagProps) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {value.map((user, index) => (
                            <Chip
                              key={user?.value?.email}
                              label={`${user?.value?.name} (${user?.value?.email})`}
                              {...getTagProps({ index })}
                            />
                          ))}
                        </Box>
                      )}
                      PopperComponent={CustomPopper}
                    />
                  </MDBox>

                  <MDBox sx={{ mt: 2 }}>
                    <MDTypography variant="subtitle2" fontWeight={"bold"}>
                      Add Email Address
                    </MDTypography>
                    <MDBox sx={{ display: "flex", gap: 1, mt: 1 }}>
                      <TextField
                        fullWidth
                        type="email"
                        value={newEmail}
                        onChange={(e) => setNewEmail(e.target.value)}
                        placeholder="Enter email address"
                      />
                      <MDButton
                        size="small"
                        color={"primary"}
                        variant="contained"
                        onClick={handleAddEmail}
                      >
                        <MDTypography fontSize={12} color={"white"}>
                          Add
                        </MDTypography>
                      </MDButton>
                    </MDBox>
                  </MDBox>

                  <MDBox sx={{ mt: 2 }}>
                    <MDTypography variant="subtitle2" fontWeight={"bold"}>
                      Email will be sent to:
                    </MDTypography>
                    <MDBox
                      sx={{ minHeight: 80, maxHeight: "150px", overflow: "auto" }}
                      border={1}
                      borderColor={"gray"}
                    >
                      {finalEmailRecipients.map((recipient, index) => (
                        <Chip
                          key={index}
                          label={`${recipient.name} (${recipient.email})`}
                          onDelete={() => handleRemoveUser(index)}
                          sx={{ m: 0.5 }}
                        />
                      ))}
                      {dropDownSelectedUsers.map((user, index) => (
                        <Chip
                          key={index}
                          label={`${user?.value?.name} (${user?.value?.email})`}
                          onDelete={() => handleRemoveDropDownUser(index)}
                          sx={{ m: 0.5 }}
                        />
                      ))}
                    </MDBox>
                  </MDBox>

                  <MDBox sx={{ mt: 2, mb: 2 }}>
                    <MDTypography marginBottom={3} variant="subtitle2" fontWeight={"bold"}>
                      Information to Send
                    </MDTypography>
                    <Autocomplete
                      multiple
                      disableCloseOnSelect={true}
                      id="search-users"
                      options={emailDataComponents}
                      getOptionLabel={(option) => `${option.label}`}
                      value={selectedEmailComponents}
                      onChange={(e, newValue) => setSelectedEmailComponents(newValue)}
                      renderInput={(params) => <TextField {...params} label="Search Data" />}
                      renderTags={(value, getTagProps) => (
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                          {value?.map((datum, index) => (
                            <Chip
                              key={datum?.label}
                              label={datum?.label}
                              {...getTagProps({ index })}
                            />
                          ))}
                        </Box>
                      )}
                      PopperComponent={CustomPopper}
                    />
                  </MDBox>
                </MDBox>
              )}
            </MDBox>
          )}

          <MDBox display="flex" justifyContent="space-between" gap={2}>
            {isEmailEditModal ? (
              <MDButton onClick={handleBack} variant="contained" color="dark" sx={{ flex: 1 }}>
                Back
              </MDButton>
            ) : (
              <MDButton onClick={onClose} variant="contained" color="error" sx={{ flex: 1 }}>
                Cancel
              </MDButton>
            )}

            {!isEmailEditModal && (
              <MDButton
                onClick={() => onSendButtonClick(true)}
                variant="contained"
                color="dark"
                sx={{ flex: 1 }}
              >
                Skip & continue
              </MDButton>
            )}

            {isEmailEditModal ? (
              <MDButton
                onClick={() => onSendButtonClick(false)}
                variant="contained"
                color="primary"
                sx={{ flex: 1 }}
              >
                Send
              </MDButton>
            ) : (
              <MDButton onClick={handleNext} variant="contained" color="primary" sx={{ flex: 1 }}>
                Next
              </MDButton>
            )}
          </MDBox>
        </MDBox>
      </MDBox>
    </Modal>
  );
};

export default SendStatusEmailModal;
